export default function secondsToDaysHoursMinutes(seconds: number): string {
	let days = Math.floor(seconds / 3600 / 24);
	let hours = Math.floor(seconds / 3600) - days * 24;
	let minutes = Math.floor(seconds / 60) - hours * 60 - days * 24;
	if(days > 0) {
		return hours === 0 ? days + "d" : days + "d " + hours + "h";
	} else {
		return minutes === 0 ? hours + "h" : hours + "h " + minutes + "m";
	}
};